
/**
 * Helper
 */
var helper = require('../../helper');
var ToastrController = new (require('../../services/ToastrController'));
var AjaxController = require('../../services/AjaxController');

$(function() {

	/*********************
	 * TYPEAHEAD SECTION *
	 *********************/
	/** Make engine object */
	var engine = new Bloodhound({
		datumTokenizer: function (datum) {
			return Bloodhound.tokenizers.whitespace(datum.name);
		},
		queryTokenizer: Bloodhound.tokenizers.whitespace,
		remote: {
			url: helper.getOrigin() + "/api/clients/ajax/%QUERY",
			wildcard: '%QUERY'
		},
		filter: function (response) {
			return $.map(response.clients, function (object) {
				return {
					id: object.id,
					name: object.name
				};
			});
		}
	});

    $.fn.dataTable.moment( 'DD/MM/YYYY' );

    var $datatable = $('#datatable-all-tickets'),
        dataTables_buttons = [
	        {
		        extend: 'csv',
		        text: 'Export as CSV',
		        exportOptions: {
			        columns: '.data-export'
		        },
	        },
	        {
		        extend: 'pdf',
		        text: 'Export as PDF',
		        exportOptions: {
			        columns: '.data-export'
		        },
		        orientation: 'landscape'
	        },
	        {
		        extend: 'print',
		        text: 'Print table',
		        exportOptions: {
			        columns: '.data-export'
		        }
	        },
            {
                extend: 'colvis'
            }
        ];

    var table = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/tickets",
            "method": 'POST',
            "data": function ( d ) {
            	if($('#complaints-all').length)
					d.complaints = true;

            	d.status_id = $('input[name="clickedStatusId"]').val();

	            d.type_id = $('select[name=type_id]').val();
	            d.urgency_id = $('select[name=urgency_id]').val();
	            d.location_id = $('select[name=location_id]').val();

	            d.created_at_from = $('input[name=created_at_from]').val();
	            d.created_at_to = $('input[name=created_at_to]').val();
	            d.date_estimated_completion_from = $('input[name=date_estimated_completion_from]').val();
	            d.date_estimated_completion_to = $('input[name=date_estimated_completion_to]').val();
	            d.client_id = $('input[id=client_id]').val();
	            d.contractor_id = $('select[name=contractor_id]').val();
	            d.certificates = $('input[name=certificates]').val();
            }
        },
        "autoWidth" : false,
        "buttons": dataTables_buttons,
        "order": [[ 0, "desc" ]],
        "columns": [
            {data: 'ticketId', name: 'tickets.id', visible: false, className: 'data-export'},
	        {data: 'created_at', name: 'tickets.created_at', className: 'data-export'},
	        {data: 'submitted_time', name: 'submitted_time', className: 'data-export'},
            {data: 'status', name: 'statusName', className: 'data-export'},
            {data: 'urgency', name: 'tickets_urgency.name', className: 'data-export'},
	        {data: 'date_estimated_completion', name: 'tickets.date_estimated_completion', className: 'data-export'},
	        {data: 'book_in_date', name: 'tickets.book_in_date', className: 'data-export'},
	        {data: 'date_completed', name: 'tickets.date_completed', className: 'data-export'},
	        {data: 'job_type', name: 'serviceName', className: 'data-export'},
            {data: 'property_id', name: 'propertyPublicId', visible: false, className: 'data-export'},
            {data: 'property_name', name: 'propertyName', className: 'data-export'},
            {data: 'description', name: 'description', visible: false, searchable: false, className: 'data-export'},
            {data: 'postcode', name: 'properties.postcode', className: 'data-export'},
            {data: 'client_view', name: 'tickets.client_view', className: "centerize", visible: false},
	        {data: 'guardian_view', name: 'tickets.guardian_view', className: "centerize", visible: false},
            {data: 'contact_first_name', name: 'users.first_name', visible: false, className: 'data-export'},
            {data: 'contact_last_name', name: 'users.last_name', visible: false, className: 'data-export'},
            {data: 'contractor', name: 'contractorName', visible: false, className: 'data-export'},
	        {data: 'cost_of_works', name: 'tickets.cost_of_works', visible: false, className: 'data-export'},
	        {data: 'assigned_member', name: 'assignedMemberFullName', className: 'data-export'},
	        {data: 'delete', name: 'delete', orderable: false, searchable: false, className: "centerize"},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action hidden-print"}
        ],
        'columnDefs': [
			{
				'targets' : 11,
				'searchable': false,
				'orderable': false,
				'render': function (data, type, row) {
					return data.length > 300 ?
						data.substr( 0, 300) + ' ...' :
						data;
				}
			},
            {
                'targets': 13,
                'searchable':true,
                'orderable':false,
                'className': 'dt-body-center tiny-column',
                'render': function (data, type, full, meta){

                    if (data[0] == 1) { // if field in database is 1 (checked)
                        return '<input id="client_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="client_view[]" value="1" checked>';
                    } else {
                        return '<input id="client_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="client_view[]" value="0">';
                    }

                }
            },
	        {
		        'targets': 14,
		        'searchable':true,
		        'orderable':false,
		        'className': 'dt-body-center tiny-column',
		        'render': function (data, type, full, meta){

			        if (data[0] == 1) { // if field in database is 1 (checked)
				        return '<input id="guardian_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="guardian_view[]" value="1" checked>';
			        } else {
				        return '<input id="guardian_view-'+data[1]+'" data-ticket-id="'+data[1]+'" type="checkbox" name="guardian_view[]" value="0">';
			        }

		        }
	        }
        ]
    });

    $('.js-ticket-activity-box').on("click", function () {
        var $this               = $(this),
            $clickedStatusId    = $('input[name="clickedStatusId"]'),
            statusId            = $(this).data('status_id');

        $clickedStatusId.val(statusId);
        table.ajax.reload();
    });

    $('#show-certificates').on('click', function () {
        var certificates = $('input[name="certificates"]');

        certificates.val(1);
        table.ajax.reload();
    });

	$('#search-form').on('submit', function(e) {

		table.draw();
		e.preventDefault();
	});

	/** Run TypeAhead */
	$('.typeahead').typeahead(null, {
		minLength: 1,
		display: 'name',
		valueKey: 'id',
		name: 'suggestions',
		displayKey: 'name',
		limit: 15,
		templates: {
			empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find clients', '</strong></div>'].join('\n'),
			suggestion: function (data) {
				return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + '</strong></p>';
			}
		},
		source: engine
	});

	/*************************************
	 * TYPEAHEAD SELECTED PROPERTY EVENT *
	 *************************************/

	$('.js-client-field-typeahead').bind('typeahead:select', function (ev, suggestions) {
		$('input[id=client_id]').val(suggestions.id);
	});

	$('.js-ticket-go-to-user-calendar').on('change', function(e) {
		var userId = $(this).val();

		if(userId > 0){
			window.location.href = helper.getOrigin() + "/tickets/member/" + userId;
		}
	});

	$(document).on('click', '.js-remove-selected-tickets', function(e){

		var msg = 'Are you sure you want to delete all selected tickets?';

		if (!confirm(msg)) {
			e.preventDefault();
			return;
		}

		e.preventDefault();

		var $checkboxes = $('.js-ticket-to-delete'),
				ticketsToDelete = [],
				url = '/api/tickets/bulk-delete';

		$checkboxes.each(function( index ) {
			var $this = $(this),
					ticketId = $this.data('ticket');

			if(this.checked){
				ticketsToDelete.push(ticketId);
			}
		});

		e.preventDefault();

		var data = {
			ticketsToDelete: ticketsToDelete,
		};
		var success = function (response) {
			//    console.log('Success');
		}
		var error = function (response) {
			//    console.log('Error');
		}

		AjaxController.prototype.send(url, data, success, error);

		window.location.reload();

	});


});
